module.exports = __webpack_public_path__ + "static/media/vf_mbag_core.2959fc5d.svg";